import { useEffect, useState } from 'react';
import { debounce } from 'lodash';
const useSwiperColGap = (swiperRef, cols, totalsCols) => {
    const [gap, setGap] = useState(0);
    const totals = totalsCols || 24;
    useEffect(() => {
        const listenGap = debounce(() => {
            if (swiperRef.current) {
                const { width } = swiperRef.current.el.getBoundingClientRect();
                const oneCol = (width - 12 * (totals - 1)) / totals;
                const gap = oneCol * cols + 12 * (cols + 1);
                setGap(gap);
            }
        }, 200);
        listenGap();
        window.addEventListener('resize', listenGap);
        return () => window.removeEventListener('resize', listenGap);
    }, []);
    return gap;
};
export default useSwiperColGap;
